import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
let InfoTitle = class InfoTitle extends Vue {
    nameClikc() {
        this.$emit("click", this.content);
    }
};
__decorate([
    Prop({ default: false })
], InfoTitle.prototype, "content", void 0);
InfoTitle = __decorate([
    Component
], InfoTitle);
export default InfoTitle;
